// Where did this visitor come from? (search / AI assistant / social / direct ...)
//
// Cookie-free and first-party. Two small jobs:
//
//  1. reportVisit()  — once per browser session, tells POST /api/site/visit the
//     referrer HOST (never the full URL), any utm_* tags and the landing path.
//     The server turns that into a channel and bumps an anonymous daily counter
//     (backend/services/trafficSource.js). Shown in CRM > Traffic Sources.
//
//  2. acquisitionHeader() — the visitor's FIRST-touch source, kept in
//     localStorage for 90 days and sent as the X-Acquisition header with API
//     calls, so a registration / enquiry is stamped with how that person first
//     found us (see storefront api.js + portalAuth.js interceptors).
//
// Nothing here can break the site: every storage / network call is try/catch'd.

const FIRST_KEY = 'sf_first_touch';
const SENT_KEY = 'sf_visit_sent';
const NINETY_DAYS = 90 * 24 * 3600 * 1000;

// Our own hosts — a referrer from these is internal navigation, not a source.
const isOwnHost = h => !!h && (h === window.location.hostname || /(^|\.)(prakaasheyewear\.com|salvadoreyewear\.com|salvadoreyewear\.com\.lk)$/i.test(h));

function referrerOrigin() {
  const ref = document.referrer;
  if (!ref) return '';
  try {
    const u = new URL(ref);
    if (isOwnHost(u.hostname)) return '';
    return `${u.protocol}//${u.hostname}`;          // host only — path/query are dropped on purpose
  } catch (_) { return ''; }
}

function currentTouch() {
  const p = new URLSearchParams(window.location.search);
  const click = p.get('gclid') || p.get('gbraid') || p.get('wbraid') ? 'google_ads'
    : p.get('msclkid') ? 'bing_ads' : p.get('ttclid') ? 'tiktok' : p.get('fbclid') ? 'fb' : '';
  const t = {
    r: referrerOrigin(),
    us: (p.get('utm_source') || '').slice(0, 60),
    um: (p.get('utm_medium') || '').slice(0, 40),
    uc: (p.get('utm_campaign') || '').slice(0, 80),
    ck: click,
    lp: window.location.pathname.slice(0, 120),
  };
  return t;
}

function readFirstTouch() {
  try {
    const raw = localStorage.getItem(FIRST_KEY);
    if (raw) {
      const o = JSON.parse(raw);
      if (o && o.t && Date.now() - o.t < NINETY_DAYS) return o;
    }
  } catch (_) { /* storage blocked */ }
  return null;
}

// Call once at app start. Records the first touch if we don't have one yet.
export function captureFirstTouch() {
  try {
    if (readFirstTouch()) return;
    localStorage.setItem(FIRST_KEY, JSON.stringify({ ...currentTouch(), t: Date.now() }));
  } catch (_) { /* ignore */ }
}

// Value for the X-Acquisition header ('' when unknown).
export function acquisitionHeader() {
  const f = readFirstTouch();
  if (!f) return '';
  const { t, ...rest } = f;                          // eslint-disable-line no-unused-vars
  const s = encodeURIComponent(JSON.stringify(rest));
  return s.length < 800 ? s : '';
}

// One anonymous count per browser session. Delayed a moment so it never competes
// with the page's own loading (LCP).
export function reportVisit() {
  try {
    if (sessionStorage.getItem(SENT_KEY)) return;
    sessionStorage.setItem(SENT_KEY, '1');
  } catch (_) { /* no sessionStorage -> may count twice, harmless */ }
  const t = currentTouch();
  setTimeout(() => {
    try {
      fetch('/api/site/visit', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(t), keepalive: true,
      }).catch(() => {});
    } catch (_) { /* ignore */ }
  }, 2500);
}
